import {endOfDay, isPast} from 'date-fns';

import type {BigCalendarEvent} from '../types/BigCalendarEvent';

/**
 * Whether the event should be drawn dimmed as already over. A timed event is over once its end
 * time passes; an all-day event stays current until its last day ends, whatever time of day its
 * `end` was normalised to.
 */
export const isPastEvent = (event: Pick<BigCalendarEvent, 'end' | 'isAllDay'>) =>
  isPast(event.isAllDay === true ? endOfDay(event.end) : event.end);
